import React, { useEffect } from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import { quoteData, contactEmail } from '../data/mockData';
import { Mail, Shield } from 'lucide-react';

const DonatePage = () => {
  // Load Give Lively widget script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://secure.givelively.org/widgets/branded_donation/aspiritech-nfp/the-nimoy-knight-foundation-remembering-leonard-nimoy.js';
    script.async = true;
    document.head.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector('script[src*="givelively.org"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0b]">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-amber-500/5 via-transparent to-transparent" />
        
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Support the Mission
          </h1>
          <p className="text-gray-300 text-lg">
            Your donation helps us continue Leonard Nimoy's legacy of hope, inspiration, and compassion for all.
          </p>
        </div>
      </section>

      {/* Donation Widget Section */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-[#141416] border border-gray-800/50 rounded-2xl p-8 md:p-12">
            <div className="text-center mb-8">
              <span className="text-amber-500 text-sm font-semibold tracking-widest uppercase">
                Secure Donation
              </span>
              <h2 className="text-3xl font-bold text-white mt-4 mb-4">
                Make a Difference Today
              </h2>
              <p className="text-gray-400">
                Every contribution, no matter the size, helps us celebrate Leonard's legacy and share his message of hope with the world.
              </p>
            </div>

            {/* Give Lively Widget */}
            <div className="bg-white rounded-xl p-4 mb-8">
              <div 
                data-widget-src="https://secure.givelively.org/donate/aspiritech-nfp/the-nimoy-knight-foundation-remembering-leonard-nimoy?ref=sd_widget" 
                id="give-lively-widget" 
                className="gl-branded-donation-widget"
              />
            </div>

            {/* Security Note */}
            <div className="flex items-center justify-center gap-2 text-gray-500 text-sm">
              <Shield className="w-4 h-4" />
              <span>Secure, encrypted donation processing via Give Lively</span>
            </div>
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <section className="py-24 bg-[#0f0f12]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="text-amber-500 text-6xl font-serif mb-6">"</div>
          <blockquote className="text-2xl md:text-3xl font-light text-white leading-relaxed mb-8">
            {quoteData.quote}
          </blockquote>
          <p className="text-amber-500 text-lg">
            — <span className="italic">{quoteData.author}</span>
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-24 bg-[#0a0a0b]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Major Gifts & Corporate Partnerships
          </h2>
          <p className="text-gray-400 text-lg mb-8">
            Interested in making a significant contribution or corporate partnership? We'd love to discuss how your support can make a lasting impact.
          </p>
          <a
            href={`mailto:${contactEmail}`}
            className="inline-flex items-center gap-2 px-8 py-3 bg-transparent border-2 border-amber-500 text-amber-500 hover:bg-amber-500 hover:text-black font-semibold rounded-full transition-all"
          >
            <Mail className="w-5 h-5" />
            Contact Us
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DonatePage;
